export default "__VITE_ASSET__DQEtghqW__"